export const environment = {
  production: true,
  envName: 'DEV',
  apiEndpoint: 'https://nutricot-api-dev-ejdfgjdwehhzf8b0.centralus-01.azurewebsites.net/api/',
  azureAd: {
    authority: 'https://login.microsoftonline.com/e365ef77-5132-4232-8ab9-c97057b68043',
    clientId: 'e5cb40db-e1d5-4f53-8dd4-5d93d07ac6d2',
    redirectUri: '/',
    postLogoutRedirectUri: 'https://nutricot.dev.glubatec.com/#/login',
    graphEndpoint: 'https://graph.microsoft.com/v1.0/me'
  },
};
